import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-privacy-policy-personalized-withoutradio',
  templateUrl: './privacyPolicyPersonalized-withoutradio.component.html',
  styleUrls: ['./privacyPolicyPersonalized-withoutradio.component.css']
})
export class PrivacyPolicyPersonalizedWithoutRadioComponent implements OnInit {
  @Input() lang: any
  platform: any

  ngOnInit(): void {
    this.platform = localStorage.getItem('platform');
  }

}
